import React, { useState } from "react";
import Spinner from "react-bootstrap/Spinner";
import { Row, Col, Form, Button } from "react-bootstrap";
import Card from "../../../components/Card";
import "./styles.css";
import { toast } from "react-toastify";
import { EtsyAPI } from "../../../js/api";
import { handleApiError } from "../../../js/helper/errorHandler";

const CreateEtsyAccount = () => {
  const [etsyData, setEtsyData] = useState({
    shop_name: "",
    access_token: "",
    refresh_token: "",
    token_expires_at: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEtsyData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleAddEtsyAccount = async () => {
    // Basic validation
    if (
      !etsyData.shop_name ||
      !etsyData.access_token ||
      !etsyData.refresh_token ||
      !etsyData.token_expires_at
    ) {
      toast.error("All fields are required.");
      return;
    }

    try {
      setIsLoading(true);
      const response = await EtsyAPI.addAccount(etsyData);
      const res = response.data;
      console.log("Etsy Account Add Response:", res);
      // return;

      if (res.status === 200 || res.status === "success") {
        toast.success("Etsy account added successfully!");

        setTimeout(() => {
          window.location.href = "/etsy/list";
        }, 800);

        setIsLoading(false);
        return;
      }

      handleApiError(res, "Failed to Add Etsy Account");
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      handleApiError(error, "Failed to Add Etsy Account");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div>
        <Row>
          <Col xl="12" lg="12">
            <Card>
              <Card.Header className="d-flex justify-content-between">
                <div className="header-title">
                  <h4 className="card-title">Add Etsy Account</h4>
                </div>
              </Card.Header>
              <Card.Body>
                <div className="new-user-info">
                  <form>
                    <div className="row">
                      <div className="col-12 col-md-10">
                        <div className="row">
                          {/* SHOP NAME */}
                          <Form.Group className="col-md-6 form-group">
                            <Form.Label>Shop Name:</Form.Label>
                            <Form.Control
                              type="text"
                              name="shop_name"
                              placeholder="Etsy Shop Name"
                              value={etsyData.shop_name}
                              onChange={handleChange}
                            />
                          </Form.Group>

                          {/* ACCESS TOKEN */}
                          <Form.Group className="col-md-6 form-group">
                            <Form.Label>Access Token:</Form.Label>
                            <Form.Control
                              type="text"
                              name="access_token"
                              placeholder="Access Token"
                              value={etsyData.access_token}
                              onChange={handleChange}
                            />
                          </Form.Group>

                          {/* REFRESH TOKEN */}
                          <Form.Group className="col-md-6 form-group">
                            <Form.Label>Refresh Token:</Form.Label>
                            <Form.Control
                              type="text"
                              name="refresh_token"
                              placeholder="Refresh Token"
                              value={etsyData.refresh_token}
                              onChange={handleChange}
                            />
                          </Form.Group>

                          {/* TOKEN EXPIRY */}
                          <Form.Group className="col-md-6 form-group">
                            <Form.Label>Token Expires At:</Form.Label>
                            <Form.Control
                              type="datetime-local"
                              name="token_expires_at"
                              value={etsyData.token_expires_at}
                              onChange={handleChange}
                            />
                          </Form.Group>
                        </div>

                        {/* BUTTON */}
                        <Button
                          type="button"
                          variant="btn btn-primary"
                          onClick={handleAddEtsyAccount}
                        >
                          Add Etsy Account
                        </Button>
                      </div>
                    </div>
                  </form>
                </div>
              </Card.Body>
            </Card>

            {/* LOADING SPINNER */}
            {isLoading && (
              <>
                <div className="d-none d-md-block">
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      background: "rgba(255, 255, 255, 0.8)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Spinner animation="border" variant="primary" />
                  </div>
                </div>

                <div className="d-md-none">
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      background: "rgba(255, 255, 255, 0.8)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginTop: "200px",
                    }}
                  >
                    <Spinner animation="border" variant="primary" />
                  </div>
                </div>
              </>
            )}
          </Col>
        </Row>
      </div>
    </>
  );
};

export default CreateEtsyAccount;
